"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionFormMigrateCtrl = void 0;
const core_api_1 = require("@ikegps/core-api");
const i18n_1 = require("../../i18n");
const index_1 = require("../../services/index");
const page_state_1 = require("../../state/page.state");
const store_1 = require("../../store");
const collection_form_migrate_modal_1 = require("../collection.form.migrate.modal/collection.form.migrate.modal");
const core_shared_1 = require("@ikegps/core-shared");
exports.CollectionFormMigrateCtrl = {
    canDisplay() {
        // Ensure all collections have the same form revision
        const forms = Array.from(new Set(page_state_1.CurrentState.Tag.collections.map((c) => c.formRevision)));
        if (forms.length !== 1) {
            return false;
        }
        // Ensure the department has the correct token
        const hasToken = index_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLLECTION_FORM_MIGRATE);
        if (!hasToken) {
            return false;
        }
        // Ensure the user is of the correct type
        const isAdminType = index_1.Services.UserProfile.isDepartmentAdmin(index_1.Services.UserProfile.get(index_1.Services.User.current.objectId)) ||
            index_1.Services.UserProfile.isDepartmentDataAdmin(index_1.Services.UserProfile.get(index_1.Services.User.current.objectId));
        if (!isAdminType) {
            return false;
        }
        // Ensure that the form of the selected collections is a PLA or Base form
        const sourceForm = store_1.AppStore.Form.get(forms[0]);
        let isPLAForm = false;
        if (sourceForm && (0, core_shared_1.readPoleForm)(sourceForm)) {
            isPLAForm = true;
        }
        return isPLAForm;
    },
    showMigrateFormModal() {
        const collections = page_state_1.CurrentState.Tag.collections;
        const modal = new collection_form_migrate_modal_1.CollectionFormMigrateModal({
            title: i18n_1.T.COLLECTION_MIGRATE_FORM_TITLE,
            confirm: i18n_1.T.COLLECTION_MIGRATE_FORM,
            success: {
                key: i18n_1.T.COLLECTION_MIGRATE_FORM_SUCCESS,
            },
        }, collections);
        modal.open();
    },
};
//# sourceMappingURL=collection.form.migrate.ctrl.js.map